<template>
  <div>Detail {{ $route.params.id }}</div>
</template>

<script>
export default {};
</script>

<style></style>
